import Vue from "vue";
import VueRouter from "vue-router";
import { auth, } from "@/firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/",
    name: "Home",
    redirect: "/pqr",
    component: () => import("@/views/Home.vue"),
    meta: { authRequired: true, },
    children: [
      {
        path: "pqr",
        component: () => import("@/views/PQR.vue"),
        children: [
          {
            name: "Pqr",
            path: "/",
            component: () => import("@/views/pqr/List.vue"),
            meta: { title: "Administración y Gestión de PQRs" },
          },
          {
            name: "UpdatePqr",
            path: "actualizar/:id",
            component: () => import("@/views/pqr/Update.vue"),
            meta: { title: "Actualizar información de PQR" },
          },
        ],
      },
      {
        path: "normatividad",
        component: () => import("@/views/Normativity.vue"),
        children: [
          {
            name: "Normativity",
            path: "/",
            component: () => import("@/views/normativity/List.vue"),
            meta: { title: "Administración y Gestión de Normatividad" },
          },
          {
            name: "CreateNormativity",
            path: "nueva",
            component: () => import("@/views/normativity/Create.vue"),
            meta: { title: "Crear nueva normativa" },
          },
          {
            name: "UpdateNormativity",
            path: "actualizar/:id",
            component: () => import("@/views/normativity/Update.vue"),
            meta: { title: "Actualizar información de Normativa" },
          }
        ],
      },
      {
        path: "usuarios",
        component: () => import("@/views/Users.vue"),
        children: [
          {
            name: "Users",
            path: "/",
            component: () => import("@/views/users/List.vue"),
            meta: { title: "Administración y Gestión de Usuarios" },
          },
          {
            name: "CreateUser",
            path: "nuevo",
            component: () => import("@/views/users/Create.vue"),
            meta: { title: "Crear nuevo usuario" },
          },
          {
            name: "UpdateUser",
            path: "actualizar/:id",
            component: () => import("@/views/users/Update.vue"),
            meta: { title: "Actualizar usuario" },
          },
        ]
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const user = auth.currentUser;
  const authRequired = to.matched.some(record => record.meta.authRequired);

  if (authRequired && !user)
    return next("/login");
  else if (!authRequired && user)
    return next("/");
  else
    return next();

});

export default router;